<template>
  <v-card color="white" class="rounded mt-4 mb-4" height="280px" elevation="0">
    <v-card-title class="subheading dark-header-bg">
      <span class="white-text pl-2 font-weight-bold"
        >Upcoming Events <span class="ml-2">&#129395;</span></span
      >
    </v-card-title>
    <v-card-text style="overflow-y: auto; height: 230px">
      <v-flex v-if="upcomingEventsLoading">Loading...</v-flex>
      <v-flex v-if="!upcomingEventsLoading && upcomingEventsList.length <= 0">
        <div>No data to show at the moment</div>
      </v-flex>
      <v-flex v-if="!upcomingEventsLoading && upcomingEventsList.length > 0">
        <div
          class="d-flex mb-3"
          v-for="(upcomingEvent, mainIndex) in upcomingEventsList"
          :key="mainIndex"
        >
          <div
            class="text-xs-center text-light-color"
            style="flex-grow: 0 !important; width: 15%"
          >
            <div>{{ upcomingEvent.date.split(" ")[0] }}</div>
            <div class="title mt-2">{{ upcomingEvent.date.split(" ")[1] }}</div>
          </div>
          <div class="ml-3 px-3" style="border-left: 2px solid #d13b55">
            <div v-if="groupEvents(upcomingEvent.events, 'eventType')">
              <!-- Render Birthdays -->
              <div
                class="mb-2"
                v-if="
                  groupEvents(upcomingEvent.events, 'eventType')['Birthday']
                "
              >
                <div class="font-weight-bold mb-2">Birthdays</div>
                <div
                  v-for="(upcomingEventItem, itemIndex) in groupEvents(
                    upcomingEvent.events,
                    'eventType'
                  )['Birthday']"
                  :key="itemIndex"
                  class="d-flex mb-1 align-center"
                >
                  <div style="flex-grow: 0 !important">
                    <v-avatar :size="20" color="grey lighten-4">
                      <img
                        :src="upcomingEventItem.userPicture"
                        :alt="upcomingEventItem.userName"
                      />
                    </v-avatar>
                  </div>
                  <div
                    class="ml-1 px-1 caption font-weight-medium text-uppercase"
                  >
                    {{ upcomingEventItem.userName }}
                  </div>
                </div>
              </div>
              <!-- Render Anniversaries -->
              <div
                v-if="
                  groupEvents(upcomingEvent.events, 'eventType')['Anniversary']
                "
              >
                <div class="font-weight-bold mb-2">Anniversaries</div>
                <div
                  v-for="(upcomingEventItem, itemIndex) in groupEvents(
                    upcomingEvent.events,
                    'eventType'
                  )['Anniversary']"
                  :key="itemIndex"
                  class="d-flex mb-1 align-center"
                >
                  <div style="flex-grow: 0 !important">
                    <v-avatar :size="20" color="grey lighten-4">
                      <img
                        :src="upcomingEventItem.userPicture"
                        :alt="upcomingEventItem.userName"
                      />
                    </v-avatar>
                  </div>
                  <div
                    class="ml-1 px-1 caption font-weight-medium text-uppercase"
                  >
                    {{ upcomingEventItem.userName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "UpcomingEvents",
  data() {
    return {
      upcomingEventsLoading: false,
      upcomingEventsList: [],
    };
  },
  methods: {
    getUpcomingEventsList() {
      this.upcomingEventsList = [];
      this.upcomingEventsLoading = true;

      axios
        .get(
          "/api/org/upcomingevents/" +
            this.$store.getters.getParentOrgIdentifier,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.upcomingEventsList = response.data;
          this.upcomingEventsLoading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Could not retrieved Upcoming Events list.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });

          this.upcomingEventsList = [];
          this.upcomingEventsLoading = false;
        });
    },
    groupEvents(itemsArray, groupBy) {
      return itemsArray.reduce((acc, obj) => {
        const key = obj[groupBy];
        if (!acc[key]) {
          acc[key] = [];
        }
        // Add object to list for given key's value
        acc[key].push(obj);
        return acc;
      }, {});
    },
  },
  beforeMount() {
    this.getUpcomingEventsList();
  },
};
</script>
